import { render, staticRenderFns } from "./modeConfig.vue?vue&type=template&id=912bd37c&scoped=true"
import script from "./modeConfig.vue?vue&type=script&lang=js"
export * from "./modeConfig.vue?vue&type=script&lang=js"
import style0 from "./modeConfig.vue?vue&type=style&index=0&id=912bd37c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912bd37c",
  null
  
)

export default component.exports